module.exports = __webpack_public_path__ + "928bdff342f7deddd8592c60e4c03485.png";